"use client";

/**
 * Puente entre el drainer offline (no-componente) y el ToastProvider global.
 * El drainer emite `window.dispatchEvent("agro:sync-error", {detail:{message}})`
 * cuando un cambio encolado es rechazado por el servidor al sincronizar; aquí lo
 * convertimos en un toast de error. Debe montarse DENTRO del <ToastProvider>.
 */

import { useEffect } from "react";
import { useToast } from "@/lib/toast-context";

export default function SyncErrorToaster() {
  const toast = useToast();
  useEffect(() => {
    const onError = (e: Event) => {
      const detail = (e as CustomEvent<{ message?: string }>).detail;
      if (detail?.message) toast.error(detail.message);
    };
    window.addEventListener("agro:sync-error", onError);
    return () => window.removeEventListener("agro:sync-error", onError);
  }, [toast]);
  return null;
}
